import "core-js/modules/es.array.concat.js";
import { Core } from "@faire/design-tokens";
import { useChatAuthorization } from "@faire/help-center-self-serve/chat/hooks/useChatAuthorization";
import { Row } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import React from "react";
import styled from "styled-components";
import { isPhoneInBusinessHours } from "../view/Phone/isPhoneInBusinessHours";
import { usePhoneAuthorization } from "../view/Phone/usePhoneAuthorization";
export var ContactUsOptionsWrapper = function ContactUsOptionsWrapper(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    disabled = _ref.disabled,
    dataTestId = _ref.dataTestId;
  var _useChatAuthorization = useChatAuthorization(),
    hasChatAccess = _useChatAuthorization.hasChatAccess,
    chatBtnEnabled = _useChatAuthorization.chatBtnEnabled;
  var _usePhoneAuthorizatio = usePhoneAuthorization(),
    hasPhoneAccess = _usePhoneAuthorizatio.hasPhoneAccess;
  var hasContactUsOptionDisabled = hasChatAccess && !chatBtnEnabled || hasPhoneAccess && !isPhoneInBusinessHours();
  return /*#__PURE__*/React.createElement(Wrapper, {
    onClick: onClick,
    "$disabled": disabled,
    "data-test-id": dataTestId,
    "$hasContactUsOptionDisabled": hasContactUsOptionDisabled
  }, children);
};
var Wrapper = styled(Row).attrs({
  align: "center",
  justify: {
    mobileAndAbove: "flex-start",
    tabletAndAbove: "space-between"
  }
}).withConfig({
  displayName: "ContactUsOptionsWrapper__Wrapper"
})(["border:1px solid ", ";border-radius:4px;padding:", ";&:hover{border:1px solid ", ";}min-width:188px;min-height:122px;", "{height:", ";width:fit-content;}", "{width:100%;}", "{width:100%;}cursor:pointer;", ""], Core.border.muted, getSpacing("2x"), Core.border["default"], responsiveMediaQueries.desktopAndAbove, function (props) {
  return props.$hasContactUsOptionDisabled ? "142px" : "fit-content";
}, responsiveMediaQueries.tablet, responsiveMediaQueries.mobile, function (_ref2) {
  var $disabled = _ref2.$disabled;
  return $disabled ? "pointer-events:none;\ncolor: ".concat(Core.text.subdued, "; \nbackground-color: ").concat(Core.surface.muted, ";") : "";
});